import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import * as vars from '../style/vars'
import { above, below } from '../style/functions'
import NewsCard from './news_card'
import LeftSvg from '../svg/left-arrow-circle'
import RightSvg from '../svg/right-arrow-circle'

const MenuChild = ({ data }) => {
	return (
		<ul>
			{data.map((item, i) => {
				return (
					<li key={i}>
						<A activeClassName='active' to={item.link.trim()} title=''>
							{item.label.trim()}
						</A>
					</li>
				)
			})}
		</ul>
	)
}

const A = styled(Link)``

export default MenuChild



// WEBPACK FOOTER //
// ./src/components/menuChild.js